
  import { Template } from '@/entities/onboarding';
  import { listFeaturedTemplates } from '@/services/api/resources/onboarding';
  import { goToCustomizeExistingTemplate } from '@/services/checklistTemplate/checklistBuiler';
  import Widget, { CollapsibleProperties } from '@/ui/components/home/Widget.vue';
  import { ResourceTable } from '@/ui/components/table/ResourceTable';
  import { useTask } from '@/ui/concerns';
  import { defineComponent, ref } from 'vue';
  import { Loader } from '@/ui/components/Loader';

  const FEATURED_TEMPLATES_COUNT = 5;

  export default defineComponent<CollapsibleProperties>({
    components: {
      Widget,
      Loader,
      ResourceTable,
    },
    props: ['collapsible'],
    setup() {
      const templates = ref<Template[]>([]);

      const getTemplatesTask = useTask(
        () => listFeaturedTemplates({ page: 1, perPage: FEATURED_TEMPLATES_COUNT }),
        response => {
          templates.value = response.data;
        },
      );

      return {
        getTemplatesTask,
        templates,
        goToCustomizeExistingTemplate,
      };
    },
  });
